import StepWizard from 'react-step-wizard'
import { CorporateStepperContextProvider } from '../../CorporateStepperContext'
import { StepCorporateUserInfo } from './StepCorporateUserInfo'
import { StepCorporateInfo } from './StepCorporateInfo'
import 'animate.css';
import { EndStepper } from '../../../sharedComponents'
import { StepperTemplate } from '../../../../../../templates'
import { LoginType } from 'components/types/Context';

export const StepperCorporate = () => {

    let custom = {
        enterRight: '',
        enterLeft: '',
        exitRight: '',
        exitLeft: '',
        intro: ''
    }

    return (
        <CorporateStepperContextProvider>
            <StepperTemplate>
                <StepWizard transitions={custom} className='w-100'>
                    <StepCorporateUserInfo />
                    <StepCorporateInfo />
                    <EndStepper loginType={LoginType.corporate} />
                </StepWizard>
            </StepperTemplate>
        </CorporateStepperContextProvider>
    )
}
